import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

interface ChartErrorStateProps {
  message: string;
}

export function ChartErrorState({ message }: ChartErrorStateProps) {
  return (
    <Box sx={{ minHeight: 220, display: "grid", alignItems: "center" }}>
      <Alert severity="error" variant="outlined">
        {message}
      </Alert>
    </Box>
  );
}
